import BaseClass from "./BaseClass";

export default class SharedCustomersWidgets extends BaseClass {
  constructor(props) {
    super(props);
    this._selected = false;
  }

  get schema() {
    return {
      id: { pane: "" },
      vendor: {
        pane: "info",
        value: this.vendorName,
        visible: !!this.vendorName
      },
      name: { pane: "info" },
      code: { pane: "info" },
      version: { pane: "info" },
      description: { pane: "info" },
      type: { pane: "" },
      secret_key: { pane: "" },
      categories: { pane: "" },

      active: { pane: "", type: Boolean },
      installs: { pane: "" },
      state: { pane: "" },

      settings: { pane: "settings" },

      created_at: { pane: "" },
      updated_at: { pane: "", value: this.timeToString(this.updated_at) },
      updated_at_amo: {
        pane: "",
        value: this.timeToString(this.updated_at_amo)
      }
    };
    // return Object.keys(this).filter(function (v) {
    //     return !(['uuid','shared-amocrm_uuid','shared-widgets_uuid', 'logo'].includes(v) || v.startsWith('_'));
    // })
  }

  get cardTitle() {
    if (this.name) {
      return `${this.name} (${this.code})`;
    }
    return this.code;
  }

  get amo() {
    try {
      if (this._embedded.sharedAmocrm.domain) {
        return this._embedded.sharedAmocrm;
      }
    } catch (e) {}
    return null;
  }

  get vendorName() {
    try {
      return this._embedded.directoryVendors.name;
    } catch (e) {
      return "";
    }
  }

  get isFKWidget() {
    return !!this.sharedWidgets_uuid;
  }

  timeToString(time) {
    try {
      return new Date(time)
        .toISOString()
        .split(".")[0]
        .replace("T", " ");
    } catch (e) {
      return time;
    }
  }

  beShownForFilterString(filter) {
    return (
      !filter ||
      (this.name || "").toLowerCase().includes(filter.toLowerCase()) ||
      (this.code || "").toLowerCase().includes(filter.toLowerCase()) ||
      (this.version || "").toLowerCase().includes(filter.toLowerCase()) ||
      (this.description || "").toLowerCase().includes(filter.toLowerCase())
    );
  }
}
